module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/may/mainvisual-present_5c010f4d5555de7ce4ca697161e5ffec.png";